import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[(_vm.viewMode === 'chart')?_c('line-chart',{staticClass:"fill-height pb-0 overflow-auto",attrs:{"type":"bar","height":220,"raw-data":_vm.accelerationZones,"chart-value-keys":[
      { key: _vm.$t('table_headers.decelerations'), type: 'bar'},
      { key: _vm.$t('table_headers.accelerations'), type: 'bar'}
    ],"plot-options":{
      bar: {
        borderRadius: 5,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'all',
        horizontal: true,
        barHeight: '60%',
        columnWidth: '90%',
      }
    },"x-value":"key","grid":{ show: false },"xaxis":{
      categories: _vm.accelerationZones.map(function (stat) { return stat.label; }),
      tickPlacement: 'between',
      min: -_vm.maxValue,
      max: _vm.maxValue,
      axisBorder: { show: false },
      labels: {
        formatter: function(value) {
          return Math.round(Math.abs(value));
        }
      }
    },"tooltip":{
      x: {
        formatter: function(value) {
          return value;
        }
      },
      y: {
        formatter: function(value) {
          return Math.abs(value);
        }
      }
    },"stacked":true},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c(VCardTitle,{staticClass:"pa-4"},[_c(VRow,{attrs:{"no-gutters":"","align":"center"}},[_c(VCol,[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100",staticStyle:{"word-break":"normal"}},[_vm._v(" "+_vm._s(_vm.$t("card_title.acceleration_zone_breakdown"))+_vm._s(_vm.aggregation ? ": " + _vm.$t(("variables." + _vm.aggregation + ".long")) : '')+" ")])]),_c(VCol,{staticClass:"ml-3",attrs:{"cols":"auto"}},[(_vm.removable)?_c(VBtn,{staticStyle:{"pointer-events":"auto"},attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('remove')}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(" fal fa-times ")])],1):_c('visual-list-toggle',{attrs:{"value":_vm.viewMode},on:{"update:value":function($event){_vm.viewMode=$event}}})],1)],1)],1)]},proxy:true}],null,false,3369095540)}):(_vm.viewMode === 'table')?_c(VCard,{staticClass:"fill-height rounded-lg"},[_c(VCardTitle,{staticClass:"pa-4"},[_c(VRow,{attrs:{"no-gutters":"","align":"center"}},[_c(VCol,[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100",staticStyle:{"word-break":"normal"}},[_vm._v(" "+_vm._s(_vm.$t("card_title.acceleration_zone_breakdown"))+_vm._s(_vm.aggregation ? ": " + _vm.$t(("variables." + _vm.aggregation + ".long")) : '')+" ")])]),_c(VCol,{staticClass:"ml-3",attrs:{"cols":"auto"}},[(!_vm.removable)?_c('visual-list-toggle',{attrs:{"value":_vm.viewMode},on:{"update:value":function($event){_vm.viewMode=$event}}}):_vm._e()],1)],1)],1),_c(VDataTable,{attrs:{"headers":_vm.tableHeaders,"items":_vm.accelerationZones,"hide-default-footer":"","disable-pagination":"","items-per-page":-1,"fixed-header":"","dense":"","height":220},scopedSlots:_vm._u([{key:"item.Decelerations",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(Math.abs(item.Decelerations))+" ")]}}])})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }